import { Color, Spacing } from '@persona-id/design-tokens';
import { ArrowRightIcon } from '@persona-id/design-tokens/icons';
import { Link, LinkProps } from 'react-router-dom-v5-compat';
import { BORDER_RADIUSES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

const Container = styled('div')`
  display: flex;
  align-items: center;
  margin-right: ${SPACINGS.base}px;
`;

const NavToLink = styled(Link)`
  cursor: pointer;
  color: ${Color.BorderIconLabelDarkGrey};

  display: flex;
  align-items: center;

  transition: background-color 0.2s;
  white-space: nowrap;
  border-radius: ${BORDER_RADIUSES.base};

  svg {
    transform: translateX(-2px);
  }

  &:hover,
  &:focus {
    svg {
      transform: translateX(2px);
    }
  }
`;

const StyledIconNavTo = styled(ArrowRightIcon)`
  flex: none;
  transition: transform 0.2s;
`;

const Label = styled('span')`
  margin-left: ${Spacing[2]};
`;

interface NavBackProps extends LinkProps {
  dataTest?: string;
}

const NavTo = ({ dataTest, children, ...linkProps }: NavBackProps) => {
  return (
    <Container>
      <NavToLink data-test={dataTest} {...linkProps}>
        <StyledIconNavTo />
        {children != null && <Label>{children}</Label>}
      </NavToLink>
    </Container>
  );
};

export default NavTo;
